import * as React from "react";

import { GridInputs } from "../../../../../../components/Functional";
import useUser from "../../../../../../hooks/useUser";

import SectionHeader from "../../components/SectionHeader";

const ArtworkPrecis = props => {
  const { formik, note } = props || {};
  const { hasPermission } = useUser();

  const inputs = {
    className: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4",
    inputs: [
      {
        className: "col-span-3",
        inputs: [
          {
            disabled: !hasPermission("UPDATE_ARTWORK_PRECIS"),
            name: "precis",
            rows: 20,
            type: "textarea",
            submitOnBlur: true,
            inputClassName: "sm:text-base line-height-1.3",
          },
        ],
      },
    ],
  };

  const detailInputProps = {
    formik,
    ...inputs,
  };

  return (
    <div className="w-full">
      <SectionHeader title="Precis" />
      <div className="w-full px-4 pb-6 sm:px-6 lg:px-8 lg:pb-8">
        {note ? <p className="text-xs text-gray-500">{note}</p> : null}
        <GridInputs {...detailInputProps} />
      </div>
    </div>
  );
};

export default ArtworkPrecis;
